<template>
  <modal
    name="orderdetail-modal"
    :width="'100%'"
    :adaptive="true"
    :height="'95%'"
    :max-width="900"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="container modal--container">
      <div class="d-flex flex-wrap justify-content-between mb-4">
        <h1>{{ this.orderDetails.restaurant_name }}</h1>
        <button @click="$modal.hide('orderdetail-modal')" class="close">
          <p aria-hidden="true" class="close-text">&times;</p>
        </button>
      </div>

      <div class="row flex-column flex-md-row mt-2">
        <div class="col mb-2 mb-md-0">
          <h2>Office:</h2>
          <span>
            {{ this.orderDetails && this.orderDetails.location_name }}
          </span>
        </div>

        <div class="col mb-2 mb-md-0">
          <h2>Order Date:</h2>
          <span>{{ this.orderDetails && this.orderDetails.order_date }}</span>
        </div>

        <div class="col mb-2 mb-md-0">
          <h2>Meal Type:</h2>
          <span>{{ this.orderDetails && this.orderDetails.meal_name }} </span>
        </div>

        <div class="col mb-2 mb-md-0">
          <div class="d-flex">
            <div class="d-flex align-items-center">
              <ResOrderStatus
                :status="this.eta"
                :tzinfo="timezone"
              ></ResOrderStatus>
            </div>
          </div>
        </div>
      </div>

      <table
        class="table table-custom table-striped__immediate-only table-bordered mt-5"
      >
        <thead>
          <tr>
            <th scope="col">Item</th>
            <th scope="col" width="75">Quantity</th>
            <th scope="col" width="105">Food Total</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in orderItems" :key="item.id">
            <td colspan="3">
              <table class="w-100 no-border-table">
                <tr>
                  <td>
                    <div class="col-12 col-md-6">
                      <p
                        v-html="
                          item.attributes.menu_item.display_name_with_html
                        "
                      ></p>
                    </div>
                  </td>

                  <td width="65" class="text-center">
                    {{ item.attributes.quantity }}
                  </td>

                  <td width="105" class="text-center">
                    <div>
                      <p>${{ parseFloat(item.attributes.price).toFixed(2) }}</p>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colspan="3">
                    <table class="w-100">
                      <tr
                        class=" mt-2"
                        v-for="option in item.attributes.order_item_options"
                        :key="option.id"
                      >
                        <td class="border-0">
                          <div class="d-flex flex-wrap">
                            <div class="col-md-3 caption">
                              <span
                                class="caption"
                                v-html="
                                  option.attributes
                                    .option_group_display_name_with_html
                                "
                              ></span>
                            </div>
                            <div class="col-md-3 caption">
                              <span
                                class="caption"
                                v-html="
                                  option.attributes
                                    .option_display_name_with_html
                                "
                              ></span>
                            </div>
                          </div>
                        </td>

                        <td width="65" class="border-0"></td>

                        <td width="105" class="text-center border-0">
                          <div>
                            <span class="caption">
                              $
                              {{
                                parseFloat(option.attributes.price).toFixed(2)
                              }}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <tr class="no-border-table">
                  <td colspan="3">
                    <div class="col-md-6">
                      <p
                        v-if="
                          item.attributes &&
                            item.attributes.special_instructions &&
                            item.attributes.special_instructions != ''
                        "
                        class="order-id mt-2"
                      >
                        Instructions:
                        {{ item.attributes.special_instructions }}
                      </p>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr
            v-if="
              (orderDetails.permanent_instructions &&
                orderDetails.permanent_instructions != '') ||
                orderDetails.cutlery
            "
          >
            <td colspan="3">
              <div class="col-md-6 col-lg-12">
                <p
                  class="order-id mt-2"
                  v-if="
                    orderDetails.permanent_instructions &&
                      orderDetails.permanent_instructions != ''
                  "
                >
                  Permanent Instructions:
                  {{ orderDetails.permanent_instructions }}
                </p>

                <p class="order-id mt-2" v-if="orderDetails.cutlery">
                  Cutlery:
                  {{ orderDetails.cutlery ? "Yes" : "No" }}
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row ml-0 ml-md-3 justify-content-between mt-4">
        <div class="col-5">
          <p>
            Food Total:
            <strong>
              $ {{ parseFloat(this.orderDetails.subtotal).toFixed(2) }}
            </strong>
          </p>

          <p>
            {{ this.taxCode }}:
            <strong
              >${{ parseFloat(this.orderDetails.hst).toFixed(2) }}
            </strong>
          </p>

          <p v-if="this.orderDetails.tip_user_select">
            Tip:
            <strong>
              ${{ parseFloat(this.orderDetails.tip).toFixed(2) }}</strong
            >
          </p>

          <p>
            Grand Total:
            <strong>
              ${{
                parseFloat(this.orderDetails.grand_total_for_user).toFixed(2)
              }}
            </strong>
          </p>
        </div>

        <div class="col-5">
          <p>
            Paid By User:
            <strong>
              ${{
                Number(this.orderDetails.amount_paid_by_employee).toFixed(2)
              }}
            </strong>
          </p>

          <p>
            Subsidized By Office:
            <strong>
              ${{
                Number(this.orderDetails.amount_paid_by_employer).toFixed(2) >
                parseFloat(this.orderDetails.grand_total_for_user).toFixed(2)
                  ? parseFloat(this.orderDetails.grand_total_for_user).toFixed(
                      2
                    )
                  : Number(this.orderDetails.amount_paid_by_employer).toFixed(2)
              }}
            </strong>
          </p>

          <div class="d-flex flex-column flex-md-row">
            <button
              v-if="
                (this.orderDetails &&
                  this.orderDetails.status &&
                  this.orderDetails.status === 'COMPLETED') ||
                  this.orderDetails.status === 'ORDER COMPLETED'
              "
              @click="openForm()"
              class="float-right modal__btn mr-2 mb-2 mb-md-0"
            >
              Leave Feedback
            </button>

            <button
              class="modal__btn"
              @click="$modal.hide('orderdetail-modal')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { getETA, getTaxName } from "../utils/api";
import { status, extractETA } from "../utils/common";
import * as typeformEmbed from "@typeform/embed";
import { mapGetters, mapState } from "vuex";
import ResOrderStatus from "./user/ResOrderStatus.vue";

export default {
  name: "OrderDetailModal",
  props: { height: { default: "auto" } },
  computed: {
    ...mapState(["employee", "currentOrganization", "timezone"]),
    ...mapGetters(["getFirstEmployeeId", "getFirstLocation"])
  },
  components: { ResOrderStatus },
  data() {
    return {
      orderDetails: {
        subtotal: 0,
        hst: 0,
        tip: 0,
        grand_total: 0
      },
      orderItems: {},
      title: "",
      subtext: "",
      eta: "",
      taxCode: "Tax"
    };
  },
  methods: {
    beforeOpen(event) {
      let self = this;
      if (event.params.body !== undefined && event.params.body.length)
        this.body = event.params.body;
      if (event.params.subtext !== undefined && event.params.subtext.length)
        this.subtext = event.params.subtext;
      if (event.params.order !== undefined) {
        this.orderDetails = event.params.order;
        this.orderItems = event.params.order.order_items;
        this.eta = event.params.eta;
        // this.setTaxCode();
      }
      if (event.params.orderDetailETA) {
        this.etaTimer = setInterval(function() {
          self.getETAData();
        }, 120000);
      }
    },
    setTaxCode() {
      getTaxName().then(res => (this.taxCode = res?.data?.taxname));
    },
    status(text) {
      return status(text);
    },
    getETAData() {
      getETA(this.orderDetails?.id, this.getFirstEmployeeId).then(response => {
        const data = response?.data;
        this.eta = extractETA(data, this.timezone);
      });
    },
    beforeClose(e) {
      clearInterval(this.etaTimer);
      document.body.classList.remove("no-scroll");
    },
    openForm() {
      let items = [];
      let typeformURL =
        "https://hungerhub.typeform.com/to/JP7fqt?email=" +
        this?.employee?.email +
        "&order_id=" +
        this.orderDetails?.id +
        "&client=" +
        this.orderDetails?.location_name +
        "&restaurant=" +
        this.orderDetails?.restaurant_name +
        "&first_name=" +
        this?.employee?.first_name +
        "&last_name=" +
        this?.employee?.last_name +
        "&date=" +
        this.orderDetails?.order_date +
        "&paid_by_user=" +
        this.orderDetails?.amount_paid_by_employee;
      for (let i = 0; i < this.orderDetails?.order_items?.length; i++) {
        let index = i + 1;
        if (
          this.orderDetails?.order_items[i]?.attributes?.special_instructions
        ) {
          items.push({
            label:
              "&item_" +
              [index] +
              "_label=" +
              this.orderDetails?.order_items[i]?.attributes?.menu_item?.title,
            instructions:
              "&item_" +
              [index] +
              "_instructions=" +
              this.orderDetails?.order_items[i]?.attributes
                ?.special_instructions,
            price:
              "&item_" +
              [index] +
              "_price=" +
              this.orderDetails?.order_items[i]?.attributes?.menu_item?.price
          });
        } else {
          items.push({
            label:
              "&item_" +
              [index] +
              "_label=" +
              this.orderDetails?.order_items[i]?.attributes.menu_item?.title,
            price:
              "&item_" +
              [index] +
              "_price=" +
              this.orderDetails?.order_items[i]?.attributes.menu_item?.price
          });
        }
        if (items[i].instructions) {
          typeformURL +=
            items[i].label + items[i].instructions + items[i].price;
        } else {
          typeformURL += items[i].label + items[i].price;
        }
      }

      const reference = typeformEmbed.makePopup(typeformURL, {
        mode: "popup",
        hideHeaders: true,
        hideFooters: true,
        onSubmit: function() {
          setTimeout(() => reference.close(), 3000);
        }
      });

      reference.open();
    }
  }
};
</script>

<style lang="scss" scoped>
.table-custom {
  width: 100%;
  table-layout: fixed;
  tr {
    padding: 10px;
  }
  td {
    padding: 5px;
    white-space: normal;
    word-break: break-word;
  }
  .no-vertical-border {
    border-top: 0px;
    border-bottom: 0px;
  }
}

.table-striped__immediate-only > tbody > tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.no-border {
  border: 0px !important;
}

.no-border-table {
  width: 100%;
  table-layout: fixed;

  td {
    border: 0 !important;
    padding: 5px;
    white-space: normal;
    word-break: break-word;
  }
  tr {
    border: 0px !important;
    padding: 5px;
  }
}

h1 {
  font-size: 24px;
  font-weight: 500;
  color: #393838;
  width: 80%;
  margin: 0;
}

h2 {
  font-size: 14px;
  font-weight: normal;
  color: #707070;
}

span {
  font-size: 16px;
  font-weight: normal;
  color: #393838;
}

.caption {
  font-size: 13px;
  font-weight: normal;
  color: #393838;
}

td {
  color: #393838;
}

p {
  color: #393838;
}

.order_status {
  margin-top: 65px;
}

.modal__btn {
  border-radius: 9px;
  background-color: #6d69d3;
  color: #fff;
  font-weight: 500;
  border: none;
  padding: 8px 20px;
}

.modal--container {
  padding: 18px 30px;
  overflow-y: auto;
  max-height: 750px;
  height: 100%;
}

.close {
  color: #000000;
}

.order-status {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #373981;
}

.close-text {
  font-size: 24px;
}

@media (max-width: 767px) {
  h1 {
    font-size: 16px;
  }

  h2 {
    font-size: 12px;
    margin-bottom: 2px;
  }

  span {
    font-size: 13px;
  }

  p {
    font-size: 11px;
  }

  .caption {
    font-size: 11px;
  }

  td {
    font-size: 11px;
  }

  .modal__btn {
    border-radius: 4px;
    font-weight: 500;
    border: none;
    font-size: 11px;
    padding: 4px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderDetailModal.vue